import React, {PureComponent} from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import cx from 'classnames';

export default class ButtonIcon extends PureComponent {
  render() {
    let {style, tooltip, tooltipPosition, children, onClick, className: classBox} = this.props;
    if (!style) style = {padding: 2};
    else if (style.padding !== 0 && !style.padding) style = {...style, padding: 2};

    return (
      <Tooltip title={tooltip} placemen={tooltipPosition}>
        <IconButton
          style={style}
          className={cx(classBox)}
          onClick={onClick}
        >
          {children}
        </IconButton>
      </Tooltip>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/common/ButtonIcon/ButtonIcon.jsx